import {Link} from "react-router-dom";
import {getUrl} from "utils";

export function Logo({path = ''}) {
  return (
    <Link to={getUrl('/')} className={'logo'}>
      <img className={'d-block'} src={require(`assets/img${path}/logo.png`)} width={108} height={24} alt={'logo'}/>
    </Link>
  )
}
